module.exports = __webpack_public_path__ + "img/bg04.fe2ca421.png";